import React, { lazy, Suspense } from 'react';

import { di } from 'react-magnetic-di';

import { fg } from '@atlaskit/platform-feature-flags';
import type { HeartbeatProps } from '@atlassian/heartbeat/types';

export const Heartbeat: React.LazyExoticComponent<React.ComponentType<HeartbeatProps>> = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_studio-foundations-heartbeat" */ '@atlassian/heartbeat'
		),
);

export const StudioHeartbeat = (): React.JSX.Element | null => {
	di(Heartbeat);

	if (!fg('studio-foundations-heartbeat')) {
		return null;
	}

	return (
		<Suspense fallback={null}>
			<Heartbeat />
		</Suspense>
	);
};
